import { LocaleDetails } from 'shared/src/types/languages.type';
import { RegionIndicatorBadge } from '../region-indicator-badge';

export const FlagContent = ({ lang }: { lang: LocaleDetails }) => {
  const flagSrc = `/flags/${lang.regionCode.toLowerCase()}.svg`;

  return (
    <>
      {/*
        The wrapper is the chip's positioning context, and it owns the gap
        before the language code so its padding box is exactly the flag — the
        chip can then be anchored to the flag's corner. The gap is `0.26rem`
        rather than the original `mr-0.5`: the chip overhangs the corner far
        enough to sit beside that text, and at `0.125rem` it cleared it by
        0.09px, which is not clearance. The extra ~1.3px is absorbed by the
        right-anchored header cluster, so nothing else moves.

        The flag itself is rendered by RegionIndicatorBadge because a subregion
        with its own flag replaces it; the country flag is still what renders on
        the server and on the first paint.
      */}
      <span className="relative inline-flex items-center mr-[0.26rem]">
        <RegionIndicatorBadge
          countryFlagSrc={flagSrc}
          country={lang.regionCode}
          lang={lang.path}
        />
      </span>
      {/* The language code is set in the brand serif, bold: it sits beside the
          flag as a label, and at 14px uppercase the serif reads as deliberate
          rather than as body text that wandered into the bar. Stated here with
          `font-display` rather than left to inherit, so it holds whatever the
          `serif-typography` flag is doing. */}
      <span className="cursor-pointer font-display text-sm font-bold uppercase">
        {lang.languageCode}
      </span>
    </>
  );
};
